export const loginName = function (rule, value, callback) {
  if (value.length < 0) {
    callback(new Error('请输入正确的用户名'))
  } else {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/_app/wwka/src/config/validate.js